import * as React from 'react';
import { UitkMenuList } from 'uitk-react-menu';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-skip-link.css';

var getClassNameList = classNames.bind(styles);
var UitkSkipLink = function (props) {
    var className = props.className, id = props.id, items = props.items;
    var wrapperClassNames = getClassNameList('uitk-skip-link uitk-skip-link-is-visually-hidden', className);
    return (React.createElement("div", { id: id, className: wrapperClassNames },
        React.createElement(UitkMenuList, { items: items })));
};
UitkSkipLink.displayName = 'UitkSkipLink';

export { UitkSkipLink };
